import { render, staticRenderFns } from "./InsightsView.vue?vue&type=template&id=52043c2e&scoped=true"
import script from "./InsightsView.vue?vue&type=script&lang=js"
export * from "./InsightsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52043c2e",
  null
  
)

export default component.exports